import Resource from '@/classes/Resource';
import ActionsRenderer from '@/components/Actions/ActionsRenderer';

export default function IndexAppBarActions({ resource }: { resource: Resource }) {
  return <ActionsRenderer resource={resource} actions={resource.indexActions} />;
}
